import * as React from "react";
import LoadingRoom from "./LoadingRoom/LoadingRoom";
import { FormProvider } from "./main/ActivationForm/Context/ActivationFormContext";
import NonAuthRoom from "./NonAuthRoom/NonAuthRoom";
import NonPendingRoom from "./NonPendingRoom/NonPendingRoom";
import OrgBanner from "./OrgBanner/OrgBanner";
// START: Codex Edit
import OrderDetailsModal from "./OrderDetails/OrderDetailsModal";
// END: Codex Edit
import ThankYou from "./ThankYou/ThankYou";
import WaitingRoom from "./WaitingRoom/WaitingRoom";
import ThemeLoader from "../common/ThemeLoader";

const ActivationPageWrapper: React.FC<{ children: any }> = ({ children }) => {
  const [logoSrc, setLogoSrc] = React.useState<string>("");

  return (
    <main data-testid="main" id="main">
      <FormProvider>
        <div data-testid="row" className="row">
          {children}
        </div>
        <ThemeLoader onLogoSrc={setLogoSrc} />
        {/* // START: Codex Edit */}
        <OrderDetailsModal />
        {/* // END: Codex Edit */}
        <OrgBanner />
        <NonAuthRoom />
        <NonPendingRoom />
        <WaitingRoom logoSrc={logoSrc} />
        <LoadingRoom logoSrc={logoSrc} />
        <ThankYou />
      </FormProvider>
    </main>
  );
};

export default ActivationPageWrapper;
